import { useEffect } from "react"
import BarChartComponentForTasks from "./BarChartComponentForTasks"
import { useGetAdminGradesByTaskMutation } from "./chartsApiSlice"
const TaskCharts = ({tasks, showNames}) => {
   const [getGrades, {
          data,
          isLoading,
          isSuccess,
          isError,
          error
      }] = useGetAdminGradesByTaskMutation()
 useEffect(() => {
   getGrades({tasks})
 }, [tasks])
  if (isLoading) return <div>Loading...</div>
  if (isError) return <div>Error: {error}</div>
  return (
    <div>
      {data && data.map((task, index) => (<div key={index}>
          <BarChartComponentForTasks data={task} showNames={showNames} />

          
          </div>
          ))}
    </div>
  )
}

export default TaskCharts